import React from "react";

const WaveDivider = ({ color = "#FFFFFF", flip = false }) => (
  <div
    className={`w-full overflow-hidden leading-none ${
      flip ? "rotate-180" : ""
    }`}
  >
    <svg
      viewBox="0 0 1200 120"
      preserveAspectRatio="none"
      className="w-full h-[80px]"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="
          M0,60
          Q100,0 200,60
          T400,60
          T600,60
          T800,60
          T1000,60
          T1200,60
          L1200,120
          L0,120
          Z
        "
        fill={color}
      />
    </svg>
  </div>
);

export default WaveDivider;
